import * as React from 'react';
import { createPreset } from '../createPreset';
import { displayClassNames, useDisplayStyles } from './useDisplayStyles.styles';
/**
 * Text preset component for the Display typography variant
 */ export const Display = createPreset({
    useStyles: useDisplayStyles,
    className: displayClassNames.root,
    displayName: 'Display'
});
